import english from "./translations/en.json";
import french from './translations/fr.json';
import spanish from './translations/es.json';
import romanian from './translations/ro.json';
import bulgarian from './translations/bg.json';
import italian from './translations/it.json'
import hebrew from './translations/he.json';
import turkish from './translations/tr.json';
import englishUs from './translations/en-us.json';

function getFormatKeys(value) {
    value = value || "";

    return value.split("{")
        .filter(key => key.includes("}"))
        .map(key => `{${key.split("}")[0]}}`);
}


function format(value, formatValues) {
    formatValues = formatValues || {};

    const formatKeys = getFormatKeys(value);
    if (value) {
        if (Array.isArray(formatValues)) {
            for (let index = 0; index < formatValues.length; ++index) {
                const formatKey = formatKeys[index] || `{${index}}`;
                while (value.includes(formatKey)) {
                    value = value.replace(formatKey, formatValues[index]);
                }
            }
        } else {
            for (let key of Object.keys(formatValues)) {
                const formatKey = `{${key}}`;
                while (value.includes(formatKey)) {
                    value = value.replace(formatKey, formatValues[key]);
                }
            }
        }
    }

    return value;
}

export class Translator {
    languages = new Map();

    constructor(locale) {
        // this.getFile = getFile;
        this.getDefaultLanguageCode = locale;
        this.languages.set("en", english);
        this.languages.set("fr", french);
        this.languages.set("es", spanish);
        this.languages.set("ro", romanian);
        this.languages.set("bg", bulgarian);
        this.languages.set("it", italian);
        this.languages.set("he", hebrew);
        this.languages.set("tr", turkish);
        this.languages.set("en-us", englishUs);
    }

    // supportedLanguages() {
    //     return [...new Set(["en", this.getDefaultLanguageCode()])];
    // }

    // async loadLanguage(languageCode = null) {
    //     languageCode = languageCode || this.getDefaultLanguageCode();

        // if (!this.languages.has(languageCode)) {
        //     const languageData = await this.getFile(languageCode);

        //     if (languageData) {
        //         this.languages.set(languageCode, languageData);
        //     }
        // }
    // }

    byKey(key, languageCode = null) {
        languageCode = languageCode || this.getDefaultLanguageCode;
        const lang = this.languages.get(languageCode);
        let result = null;
        if (lang) {
            result = lang[key] || null;
        }

        if (!result && languageCode !== "en") {
            return this.byKey(key, "en");
        }

        // TODO figure out a way to make this more useful. At the moment clutters up the console log.
        // if (!result) {
        //   console.warn("Missing key", key, "for language", languageCode);
        // }

        return result || key;
    }

    byValue(value, languageCode = null) {
        value = value || "";
        const english = this.languages.get("en");
        const keys = Object.keys(english).filter((key) => english[key] === value.trim() || english[key] === value);
        if (keys.length === 0) {
            return value;
        }

        const result = keys.map(key => [key, this.byKey(key, languageCode)])
            .filter(([key, value]) => key !== value)[0];

        return result ? result.pop() : value;
    }

    byKeyFormatted(key, formatValues = {}, languageCode = null) {
        return format(this.byKey(key, languageCode), formatValues);
    }

    byValueFormatted(value, formatValues = {}, languageCode = null) {
        return format(this.byValue(value, languageCode), formatValues);
    }
}
